import { connect } from 'react-redux'
import styled from 'styled-components'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import AlwaysOnOfferPropertyCancellationPolicies from './AlwaysOnOfferPropertyCancellationPolicies'
import ConnectionCancellationPolicies from './ConnectionCancellationPolicies'
import { buildAvailableRateKey } from 'lib/offer/availabilityUtils'
import { isValidOccupancy } from 'lib/offer/occupancyUtils'

const CancellationPoliciesLoadingIndicator = styled(LoadingIndicator)`
  padding: 0;
`

const EmptyAvailableRates: App.OfferAvailableRates = {
  fetching: false,
  error: undefined,
  key: '',
  rates: [],
}

interface Props {
  offerId: string
  uniqueKey?: string
  checkInDate?: string
  checkOutDate?: string
  occupants?: Array<App.Occupants>
  cancellationPolicy?: App.OfferCancellationPolicy
  fetching?: boolean
  hideNonRefundableMessage?: boolean
  textLinkFormat?: boolean
  hideIndicator?: boolean
  useDynamicCancellationPolicies?: boolean
  timezoneOffset?: number
  hideExcludesFlights?: boolean
  offerType?: string
  offerAvailableRates?: App.OfferAvailableRates
}

function TAOCancellationPolicies(props: Props) {
  const {
    offerAvailableRates,
    checkInDate,
    uniqueKey,
    fetching,
    cancellationPolicy,
    hideNonRefundableMessage,
    textLinkFormat,
    hideIndicator,
    useDynamicCancellationPolicies,
    timezoneOffset,
    hideExcludesFlights,
    offerType,
  } = props

  const fetchingData = fetching || !!offerAvailableRates?.fetching
  const pkgAvailableRate = offerAvailableRates?.rates?.find(rate => rate.packageUniqueKey === uniqueKey)

  return <>
    {!useDynamicCancellationPolicies && cancellationPolicy &&
      <AlwaysOnOfferPropertyCancellationPolicies
        cancellationPolicy={cancellationPolicy}
        checkInDate={checkInDate}
        propertyTimezoneOffset={timezoneOffset}
        hideNonRefundableMessage={hideNonRefundableMessage}
        textLinkFormat={textLinkFormat}
        offerType={offerType}
      />}
    {useDynamicCancellationPolicies && fetchingData && !hideIndicator && (
      <CancellationPoliciesLoadingIndicator visible={fetchingData} opaque inline />
    )}
    {useDynamicCancellationPolicies && !fetchingData && pkgAvailableRate?.cancellationPolicies && (
      <ConnectionCancellationPolicies
        cancellationPolicy={cancellationPolicy}
        cancellationPolicies={pkgAvailableRate.cancellationPolicies}
        checkIn={checkInDate}
        hideNonRefundableMessage={hideNonRefundableMessage}
        textLinkFormat={textLinkFormat}
        hideExcludesFlights={hideExcludesFlights}
        offerType={offerType}
      />
    )}
  </>
}

function mapStateToProps(state: App.State, ownProps: Props) {
  const { offerId, checkInDate, checkOutDate, occupants } = ownProps
  const availableRatesKey = (checkInDate && checkOutDate && occupants && isValidOccupancy(...occupants)) ? buildAvailableRateKey(checkInDate, checkOutDate, occupants) : ''

  return {
    fetching: !!(state.offer.offersLoading[ownProps.offerId]),
    offerAvailableRates: state.offer.offerAvailableRates[offerId]?.[availableRatesKey] ?? EmptyAvailableRates,
  }
}

export default connect(mapStateToProps)(TAOCancellationPolicies)
